// components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaLinkedin, FaTwitter, FaFacebook } from 'react-icons/fa';

const logoWhite = process.env.PUBLIC_URL + '/assets/images/comtel-logo-darkmode.png';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-column brand-column">
              <div className="footer-logo">
                <img src={logoWhite} alt="Comtel Infosystems" />
              </div>
              <p>
                Powering financial market infrastructure since 1992. Specialized data center,
                networking, and hardware solutions for NSE/BSE/MCX brokers and financial institutions.
                Serving 400+ satisfied customers with 120+ skilled employees.
              </p>
              <div className="social-links">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <FaLinkedin />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <FaTwitter />
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FaFacebook />
                </a>
              </div>
              <div className="certification-badge">
                <img 
                  src="/assets/images/iso-27001-badge.png" 
                  alt="ISO/IEC 27001:2022 Certified" 
                  className="cert-badge"
                  title="Information Security Management System Certified"
                />
                <p className="cert-text">ISO/IEC 27001:2022 Certified</p>
              </div>
            </div>
            
            <div className="footer-column">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/financial-solutions">Financial Solutions</Link></li>
                <li><Link to="/server-builder">Server Builder</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/resources">Resources</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4>Our Services</h4>
              <ul>
                <li><Link to="/services#datacenter">Data Center Solutions</Link></li>
                <li><Link to="/services#networking">Networking Solutions</Link></li>
                <li><Link to="/services#hardware">Hardware Solutions</Link></li>
                <li><Link to="/services#support">Technical Support</Link></li>
                <li><Link to="/financial-solutions">Trading Infrastructure</Link></li>
                <li><Link to="/financial-solutions#exchanges">Exchange Connectivity</Link></li>
                <li><Link to="/server-builder">Custom Server Builder</Link></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4>Contact Us</h4>
              <address>
                201, Jet Prime, Kumar Printers Industrial Estate<br />
                Gundavli, Suren Road, Andheri East<br />
                Mumbai, Maharashtra - 400093
              </address>
              <p><strong>Email:</strong> <a href="mailto:sales.comtel@comtelindia.com">sales.comtel@comtelindia.com</a></p>
              <p><strong>Website:</strong> <a href="https://www.comtelindia.com">www.comtelindia.com</a></p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Comtel Infosystems Private Limited. All rights reserved.</p>
          <div className="footer-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
            <Link to="/corporate-disclosure">Corporate Disclosure</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;